module.exports = __webpack_public_path__ + "media/flat-naped-top2-ec-phev.a1f3c1d7.mp4";